import { render, staticRenderFns } from "./sidenav.vue?vue&type=template&id=a6e56628&"
import script from "./sidenav.vue?vue&type=script&lang=js&"
export * from "./sidenav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports